module.exports = __webpack_public_path__ + "static/media/toelogic-4.356f2f0c.jpg";